@if (sidebarService.isOpen() ) {
<div
  class="inter z-10 h-full w-[250px] fixed mt-[80px] left-0 top-0 custom-max-h overflow-y-auto overflow-x-hidden border-r bg-white px-3 border-[#E4E9EF] shadow-md pt-3"
>
  <a
    (click)="navigateToUrl('/menu')"
    class="flex w-[225px] h-[40px] px-2 mb-2 items-center cursor-pointer rounded-sm font-medium hover:bg-[#eef5ff] {{
      currentPath === '/menu' ? 'bg-[#E3ECFB] text-[#005FFF]' : ''
    }} group"
  >
    <div class="flex items-center justify-center w-12">
      <span
        class="material-symbols-outlined group-hover:text-[26px]! text-[20px]! transition-all"
      >
        home
      </span>
    </div>
    Home
  </a>
  @for (item of sidebarSystems; track $index) {
    @if(item.descripcion !== "" && item.nombre !== "" && item.ruta !== "" && item.icono !== "") {
      <div
        title="{{ item.descripcion }}"
        (click)="handleEnterSystem(item)"
        class="flex w-[225px] h-[30px] px-2 mb-2 items-center cursor-pointer rounded-sm font-medium hover:bg-[#eef5ff] group {{
      item.ruta.includes(currentPath) ? 'bg-[#E3ECFB] text-[#005FFF]' : ''
    }}"
      >
        <div class="flex items-center justify-center w-12">
        <span
          class="material-symbols-outlined group-hover:text-[26px]! text-[20px]! transition-all"
        >
          {{ item.icono ? item.icono : "apps"}}
        </span>
        </div>
        {{
          item.descripcion.length > 21
            ? item.descripcion.substring(0, 21) + "..."
            : item.descripcion
        }}
      </div>
    }

  }
  <!-- config -->
  @if ( isAdmin ) {

  <div class="{{ isDropdownOpen ? 'h-[150px]' : 'h-[32px]' }}"></div>

  <div class="fixed bottom-0 bg-white pb-2">
    <a
      (click)="toggleDropdown()"
      class="bg-white inter flex justify-between w-[225px] h-[30px] px-2 items-center cursor-pointer rounded-sm font-medium hover:bg-[#eef5ff] group"
    >
      <div class="flex items-center">
        <div class="flex items-center justify-center w-12">
          <span
            class="material-symbols-outlined group-hover:text-[26px]! text-[20px]! transition-all"
          >
            settings
          </span>
        </div>
        <p>Configuraciones</p>
      </div>
      <span
        class="material-symbols-outlined text-[20px]! transition-all {{
          isDropdownOpen ? 'rotate-180' : ''
        }}"
        >keyboard_arrow_down</span
      >
    </a>
    @if (isDropdownOpen) {
    <div class="w-[225px] px-2">
      @for (item of items; track $index) {
      <a
        (click)="navigateToUrl(item.url)"
        class="flex group pl-4 hover:bg-[#eef5ff]  cursor-pointer rounded-sm items-center h-[30px] font-medium
        {{ currentPath === item.url ? 'bg-[#E3ECFB] text-[#005FFF]' : '' }}"
      >
        <div class="flex items-center justify-center w-12">
          <span
            class="material-symbols-outlined group-hover:text-[26px]! text-[20px]! transition-all"
          >
            {{ item.icon }}
          </span>
        </div>
        {{ item.nombre }}
      </a>
      }
    </div>
    }
  </div>
  }
</div>
}
